import { useAuctioneersApi } from '@api/auctioneers';
import { BasePreloader, Pagination, SEO } from '@components';
import { urlSearchStore, usePageStore, useUrlSearchStore } from '@stores';
import { AuctioneersWebResponse } from '@types';
import * as routes from '@routes';
import React, { useEffect, useState } from 'react';
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';
import { FrontAuctioneerFilter } from './FrontAuctioneerFilter';
import { FrontAuctioneerItem } from './FrontAuctioneerItem';
import { useNavigate, useLocation } from 'react-router-dom';

export const FrontAuctioneerList = () => {
  const navigate = useNavigate();
  const auctioneersApi = useAuctioneersApi();
  const location = useLocation();
  const urlSearchState = useUrlSearchStore();
  const pageState = usePageStore();
  const [loaded, setLoaded] = useState(false);
  const [auctioneers, setAuctioneers] = useState<Array<AuctioneersWebResponse>>([]);
  const [dataLen, setDataLen] = useState(0);
  const defaultQuery = React.useMemo(
    () => ({
      page: withDefault(NumberParam, 1),
      perPage: withDefault(NumberParam, 10),
      ic: withDefault(StringParam, undefined),
      regions: withDefault(StringParam, undefined),
      search: withDefault(StringParam, undefined),
    }),
    []
  );
  const [query, setQuery] = useQueryParams(defaultQuery);

  useEffect(() => {
    if (urlSearchState.frontAuctioneerList) {
      navigate(`${pageState.getPagePath(routes.front.AUCTIONEER_LIST)}${urlSearchState.frontAuctioneerList}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    loadData();
    urlSearchStore.setState({ frontAuctioneerList: location.search });
    return () => auctioneersApi.cancelAllRequests();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, query]);

  const loadData = async () => {
    setLoaded(false);
    try {
      const response = await auctioneersApi.getWebAuctioneers(query);
      setAuctioneers(response.data.data);
      setDataLen(response.data.total as number);
      setLoaded(true);
    } catch (err) {
      if (!err.response) {
        return;
      }
      setLoaded(true);
    }
  };

  return (
    <>
      <SEO title="Seznam dražebníků" />
      <h1 className="auctioneers-page-title">Seznam dražebníků</h1>
      <FrontAuctioneerFilter values={query} onSubmit={(values) => setQuery(values, 'push')} />
      {!loaded ? (
        <div className="d-flex align-items-center justify-content-center">
          <BasePreloader />
        </div>
      ) : (
        <div className="component-front-auctioneers-list">
          <div className="list-items">
            {auctioneers.map((auctioneer) => (
              <FrontAuctioneerItem auctioneer={auctioneer} key={auctioneer.id} />
            ))}
          </div>
          {dataLen > query.perPage && (
            <div className="mt-2">
              <Pagination
                page={query.page}
                perPage={query.perPage}
                totalRows={dataLen}
                onPageChange={(page) => setQuery({ ...query, page: page }, 'push')}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};
